export default "__VITE_PUBLIC_ASSET__3a17a51c__"